export class RouterAction {
  public static readonly type = '[Router] Add item';
  constructor(public payload: string) { }
}
